const models = [
    {
        id: 1,
        name: "bedside",
        imgURL: "bedside.png",
        modelSRC: [
                "bedside/var1/bedside.gltf",
                "bedside/var2/bedside.gltf",
                "bedside/var3/bedside.gltf",
                ],
        iosSRC: [
                "bedside/var1/bedside.usdz",
                "bedside/var2/bedside.usdz",
                "bedside/var3/bedside.usdz"
            ],
        variants: [
            "bedside-var-01.png",
            "bedside-var-02.png",
            "bedside-var-03.png"
        ] // TODO: Add variants
    },
    {
        id: 2,
        name: "desk",
        imgURL: "desk.png",
        modelSRC: [
            "desk/var1/desk.gltf",
            "desk/var2/desk.gltf",
            ],
        iosSRC: [
            "desk/var1/desk.usdz",
            "desk/var2/desk.usdz"
        ],
        variants: [
            "desk-var-01.png",
            "desk-var-02.png"
        ],
    },
    {
        id: 3,
        name: "sofa",
        imgURL: "sofa.png",
        modelSRC: [
            "sofa/leather/sofa.gltf",
            "sofa/fabric/sofa.gltf"
        ],
        iosSRC: [
            "sofa/leather/sofa.usdz",
            "sofa/fabric/sofa.usdz"
        ],
        variants: [ "sofa-leather.png", "sofa-fabric.png"],
    },
    {
        id: 4,
        name: "soda-can",
        imgURL: "soda-can.png",
        modelSRC: ["soda-can/soda-can.gltf",],
        iosSRC: [
            "soda-can/soda-can.usdz"
        ],
        variants: [],
    },
    {
        id: 5,
        name: "plate",
        imgURL: "plate.png",
        modelSRC: [
            "plate/var1/plate.gltf",
            "plate/var2/plate.gltf",
        ],
        iosSRC: [
            "plate/var1/plate.usdz",
            "plate/var2/plate.usdz",
        ],
        variants: [
            "plate-var-01.png",
            "plate-var-02.png"
        ],
    },
    {
        id: 6,
        name: "sink-unit",
        imgURL: "sink.png",
        modelSRC: [
            "sink-unit/var1/sink-unit.gltf",
            "sink-unit/var2/sink-unit.gltf"
        ],
        iosSRC: [
            "sink-unit/var1/sink.usdz",
            "sink-unit/var2/sink.usdz",
        ],
        variants: [
            "sink-unit-var-01.png",
            "sink-unit-var-02.png"
        ],
    },
    {
        id: 7,
        name: "dresser",
        imgURL: "dresser.png",
        modelSRC: [
            "dresser/var1/dresser.gltf",
            "dresser/var2/dresser.gltf",
            "dresser/var3/dresser.gltf",
        ],
        iosSRC: [
            "dresser/var1/dresser.usdz",
            "dresser/var2/dresser.usdz",
            "dresser/var3/dresser.usdz"
        ],
        variants:[
            "dresser-var-01.png",
            "dresser-var-02.png",
            "dresser-var-03.png"
        ]
    },
    {
        id: 8,
        name: "bookshelf",
        imgURL: "bookshelf.png",
        modelSRC: [
            "bookshelf/var1/bookshelf.gltf",
            "bookshelf/var2/bookshelf.gltf"],
        iosSRC: [
            "bookshelf/var1/bookshelf.usdz",
            "bookshelf/var2/bookshelf.usdz",
        ],
        variants: [
            "bookshelf-var-01.png",
            "bookshelf-var-02.png"
        ],
    },
    {
        id: 9,
        name: "coffeetable",
        imgURL: "coffeetable.png",
        modelSRC: [
            "coffeetable/var1/coffeetable.gltf",
            "coffeetable/var2/coffeetable.gltf",
            "coffeetable/var3/coffeetable.gltf",
        ],
        iosSRC: [
            "coffeetable/var1/coffeetable.usdz",
            "coffeetable/var2/coffeetable.usdz",
            "coffeetable/var3/coffeetable.usdz",
        ],
        variants: [
            "coffeetable-var-01.png", 
            "coffeetable-var-02.png",
            "coffeetable-var-03.png",
    
        ]
    },
    {
        id: 10,
        name: "ac-unit",
        imgURL: "acunit.png",
        modelSRC: ["ac-unit/ac-unit.gltf"],
        iosSRC: [
            "ac-unit/ac-unit.usdz"
        ],
        variants: [],
    },
    {
        id: 11,
        name: "frame",
        imgURL: "frame.png",
        modelSRC: ["frame/frame.gltf"],
        iosSRC: [
            "frame/frame.usdz"
        ],
        variants: [],
        arWall: true,
    },
    {
        id: 12,
        name: "plane-engine",
        imgURL: "plane-engine.png",
        modelSRC: ["plane-engine/plane-engine.gltf"],
        iosSRC: [
            "plane-engine/plane-engine.usdz"
        ],
        variants: [],
        hasSpecialCameraOrbit: true,
        cameraOrbit: "180deg 65deg 25m"
    },
  ]

  export default models